export default "__VITE_ASSET__CElVDyur__"